import { all } from 'redux-saga/effects';
import authSagas from './app/auth.saga';
import { actions as authActions } from './app/auth.duck';

export default function* rootSaga() {
    yield all(authSagas(authActions.redirectToMainRoute));
}
